export default __webpack_public_path__ + "static/category_image_fight_text_spam-a58b385e45c2fc507ba2d7703517e3a0.webp";